import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    oddRow: {
      backgroundColor: "#f3f3f3",
    },
    crewLabelCol: {
      minWidth: 110,
      textAlign: "left",
      display: "inline-block",
    },
    crewColonCol: {
      width: 24,
      display: "inline-flex",
      justifyContent: "center",
    },
    crewValueCol: {
      minWidth: 80,
      display: "inline-block",
    },
    crewColVisitDate: {
      textAlign: "left",
    },
    crewColStatus: {
      textAlign: "left",
    },
    crewColDeductions: {
      textAlign: "left",
    },
    crewHeaderRow: {
      alignItems: "flex-end",
    },
    crewSummaryWrap: {
      flex: "1 1 auto",
      minWidth: 200,
    },
    expandAllWrap: {
      flexShrink: 0,
      textAlign: "right",
      alignSelf: "flex-end",
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.25),
    },
    expandAllLabel: {
      color: "rgba(0, 0, 0, 0.6)",
      fontSize: 13,
      fontWeight: 600,
      lineHeight: "16px",
      marginBottom: theme.spacing(0.5),
    },
    expandAllButton: {
      minWidth: 80,
      borderColor: "#bdbdbd",
      color: "#000",
      fontSize: 11,
      fontWeight: 600,
      lineHeight: "14px",
      borderRadius: 0,
      textTransform: "none",
      padding: "4px 10px",
      "&:hover": {
        borderColor: "#9e9e9e",
        backgroundColor: "#f9f9f9",
      },
    },
    dispatchRowContainer: {
      backgroundColor: "#f7f7f7",
      border: "1px solid #ececec",
      borderBottom: "none",
    },
    dispatchRowHeader: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "nowrap",
      minHeight: 36,
    },
    dispatchExpandIcon: {
      width: 20,
      height: 20,
      borderRadius: 0,
      color: "rgba(0, 0, 0, 0.7)",
      padding: 0,
      marginRight: theme.spacing(0.75),
      "& .MuiSvgIcon-root": {
        fontSize: 16,
      },
    },
    deductionsSection: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderTop: "1px solid #ececec",
      backgroundColor: "#fff",
    },
    deductionsTitle: {
      fontSize: 14,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    deductionRow: {
      marginTop: theme.spacing(0.75),
      border: "1px solid #ececec",
      backgroundColor: "#fff",
      padding: theme.spacing(0.75, 1),
    },
    labelText: {
      color: "rgba(0, 0, 0, 0.6)",
      fontSize: 14,
    },
    valueText: {
      fontSize: 14,
    },
  })
);
